// ========================================
// UTILITAIRE - Read Time
// Calculer le temps de lecture d'un article
// ========================================

/**
 * Calculer le temps de lecture en minutes
 * Basé sur une moyenne de 200 mots par minute
 */
export const calculateReadTime = (content) => {
  if (!content) return 1;
  
  // Supprimer les balises HTML
  const textOnly = content.replace(/<[^>]*>/g, '');
  
  // Compter les mots
  const words = textOnly.trim().split(/\s+/).length;
  
  // Calculer le temps (200 mots/min en moyenne)
  const minutes = Math.ceil(words / 200);
  
  return Math.max(1, minutes);
};

/**
 * Formater le temps de lecture
 */
export const formatReadTime = (content) => {
  const minutes = calculateReadTime(content);
  return `${minutes} min de lecture`;
};

export default calculateReadTime;